<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y disabled> 
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(schedule_status)" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(schedule_status)}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <!-- details -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Payment Details</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Due On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{loan_schedule.dueOn | moment('MMM DD, YYYY')}} 
                                </v-flex>  
                            </v-layout>      
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Amount Due :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    PHP {{numFormat.formatNumber(loan_schedule.amountDue)}} 
                                </v-flex>  
                            </v-layout>  
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Status :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    {{commonfn.getStatusDescription(loan_schedule.status)}} 
                                </v-flex>  
                            </v-layout>    
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Processed On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <span v-if="loan_schedule.processedOn!=null">{{loan_schedule.processedOn | moment('MMM DD, YYYY')}}</span>
                                    <span v-else>Not Available</span>
                                </v-flex>  
                            </v-layout>
                            <v-layout v-if="loan_schedule.processedOn!=null" row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Processed By :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="loan_schedule.processedByAvatar"></v-img>
                                        </v-avatar>
                                        {{loan_schedule.processedByName}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Paid On :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <span v-if="loan_schedule.paidOn!=null">{{loan_schedule.paidOn | moment('MMM DD, YYYY')}}</span>
                                    <span v-else>Not Available</span>
                                </v-flex>  
                            </v-layout>
                            <v-layout v-if="loan_schedule.paidOn!=null" row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs4 class="text-xs-left">
                                    Paid By :
                                </v-flex>
                                <v-flex xs8 class="font-weight-bold text-xs-left">
                                    <v-chip style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="loan_schedule.processedByAvatar"></v-img>
                                        </v-avatar>
                                        {{loan_schedule.processedByName}} 
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>      
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedLoanScheduleId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedLoanScheduleId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import loansApi from '@/api/loans'
import commonfn from '@/common/functions'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'

export default {     
    name: 'MyLoans',
    metaInfo: {
        title: 'My Loan Payments Schedule',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Loans' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        return {
            commonfn,
            numFormat,
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            menu_status: false,
            my_profile: null,
            loan_schedule: null
        }
    },
    methods: {
        async getScheduleDetails(show_loading) {
            try {
                this.loading = show_loading
                const response = await loansApi.getMyLoansSchedule(this.selectedLoanScheduleId)
                if (response.status == 200) {
                    this.loan_schedule = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getScheduleDetails(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payment Schedule Details'
        })

        this.getScheduleDetails(true)
    },
    computed: {
        selectedLoanScheduleId() {
            return this.$route.params.loanScheduleId
        },
        commentsData() {
            if (this.loan_schedule) {
                return {
                    pageQueryId: this.selectedLoanScheduleId,
                    pageItemCreatedBy: this.loan_schedule.userId,
                    pageLink: this.$router.currentRoute.path.replace('/myloans/','/loans/'), //should send to owner link
                    pageKey: pageKeys.loans,
                    notificationTypeId: notificationTypes.loan_payment_schedule
                }
            }
        },
        schedule_status() {
            if (this.loan_schedule) return this.loan_schedule.status
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>